let appStoreModule = {
    namespaced: true,
    state: {
        role: '',
        options:'',
    },
    getters:{
        role: function(state){
            return state.role;
        },
        options: function(state){
            return state.options?state.options:{};
        }
    },
    actions: {
        setRole(state, data) {

        }
    },
    mutations: {
        setRole(state, data) {
            state.role = data
        },
        setOptions(state, data) {
            state.options = data
        }
    }
}

export default appStoreModule;